var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"clearable":"","prepend-inner-icon":"mdi-wallet-travel","items":_vm.items,"label":_vm.$t(_vm.label)},on:{"input":function($event){return _vm.$emit('update:filter', _vm.filter)}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})
}
var staticRenderFns = []

export { render, staticRenderFns }